import { Box, Paper } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { cardSx } from './styles';

type ReleaseToDeconCardProps = PropsWithChildren<{
  sx?: Record<string, unknown>;
}>;

export const ReleaseToDeconCard = ({ children, sx }: ReleaseToDeconCardProps) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: { xs: 'center', md: 'stretch' },
      justifyContent: { xs: 'center', md: 'flex-start' },
    }}
  >
    <Paper sx={{ ...cardSx, ...(sx ?? {}) }}>{children}</Paper>
  </Box>
);
